import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isViewAsSession } from '../core/view-as';

/** "View as" never opens the live chat page: it goes to the read-only one, keeping the chat it was asked for. */
export const viewAsChatRedirect: CanActivateFn = (route) => {
  if (!isViewAsSession()) return true;
  const channelId = route.paramMap.get('channelId') || route.queryParamMap.get('channelId') || '';
  return inject(Router).createUrlTree(['/view-as-chats'], channelId ? { queryParams: { channelId } } : {});
};

/** The read-only chat page is for "View as" only; anyone else goes to the live chat page. */
export const viewAsOnly: CanActivateFn = () =>
  isViewAsSession() ? true : inject(Router).createUrlTree(['/main-chat']);
